// components/ProductCard/ProductCard.js
import { useState } from 'react';
import { createPortal } from 'react-dom';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  const [showModal, setShowModal] = useState(false);

  const handleCardClick = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <div className="product-card" onClick={handleCardClick}>
        <div className="product-image-container">
          <img 
            src={product.image || 'placeholder-image-url'} 
            alt={product.name} 
            className='product-image'
            style={{ objectPosition: product.imageOrientation === 'horizontal' ? 'center' : 'top' }}
          />
          <div className="product-overlay">
            <h3>{product.name}</h3>
            <div className="category-pill">{product.category}</div>
          </div>
        </div>
      </div>

      {showModal &&
        createPortal(
          <div className="modal-backdrop" onClick={handleCloseModal}>
            <div className="modal-container" onClick={(e) => e.stopPropagation()}>
              <div className="modal-card">
                <div className="modal-image-wrapper">
                  <img 
                    src={product.image || 'placeholder-image-url'} 
                    alt={product.name} 
                    className={`modal-image ${product.imageOrientation === 'horizontal' ? 'horizontal' : 'vertical'}`}
                  />
                </div>
                <div className="modal-content">
                  <h2>{product.name}</h2>
                  <div className="modal-meta">
                    <span className="modal-category">{product.category}</span>
                  </div>
                  <p className="modal-description">{product.description}</p>
                  <button className="close-button" onClick={handleCloseModal}>
                    <span className="icon">✕</span> Close
                  </button>
                </div>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};

export default ProductCard;